/**
 * Ekiboost Cart Drawer — Full AJAX cart logic
 * Style DIJO — single tier progress bar, delivery estimate, shipping toggle
 */
(function() {
  'use strict';

  /* ===== CONFIG ===== */
  var FREE_SHIPPING_THRESHOLD = 6000; /* 60 EUR en centimes */
  var SHIPPING_COST = 490; /* 4,90 EUR in cents */

  /* ===== DOM REFS ===== */
  var drawer, overlay, closeBtn;
  var drawerBody, drawerItems, drawerEmpty, drawerFooter;
  var drawerCount;
  var progressEl, progressMsg, progressFill;
  var subtotalLabel, subtotalCurrent, subtotalCompare;
  var checkoutBtn, checkoutText;
  var shippingRow, shippingCost;
  var upsellSection, upsellGrid;

  /* ===== STATE ===== */
  var cartData = null;
  var isOpen = false;
  var isUpdating = false;
  var upsellProducts = [];

  /* ===== INIT ===== */
  function init() {
    drawer = document.getElementById('EkiCartDrawer');
    overlay = document.getElementById('EkiDrawerOverlay');
    closeBtn = document.getElementById('EkiDrawerClose');
    drawerBody = document.getElementById('EkiDrawerBody');
    drawerItems = document.getElementById('EkiDrawerItems');
    drawerEmpty = document.getElementById('EkiDrawerEmpty');
    drawerFooter = document.getElementById('EkiDrawerFooter');
    drawerCount = document.getElementById('EkiDrawerCount');
    progressEl = document.getElementById('EkiProgress');
    progressMsg = document.getElementById('EkiProgressMsg');
    progressFill = document.getElementById('EkiProgressFill');
    subtotalLabel = document.getElementById('EkiSubtotalLabel');
    subtotalCurrent = document.getElementById('EkiSubtotalCurrent');
    subtotalCompare = document.getElementById('EkiSubtotalCompare');
    checkoutBtn = document.getElementById('EkiCheckoutBtn');
    checkoutText = document.getElementById('EkiCheckoutText');
    shippingRow = document.getElementById('EkiShippingRow');
    shippingCost = document.getElementById('EkiShippingCost');
    upsellSection = document.getElementById('EkiDrawerUpsell');
    upsellGrid = document.getElementById('EkiUpsellGrid');

    if (!drawer) return;

    loadUpsellData();
    bindEvents();
    fetchCart(false);
  }

  /* ===== LOAD UPSELL PRODUCT DATA ===== */
  function loadUpsellData() {
    var dataEl = document.getElementById('EkiUpsellData');
    if (!dataEl) return;
    try {
      upsellProducts = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.warn('Eki Cart: could not parse upsell data', e);
      upsellProducts = [];
    }
  }

  /* ===== EVENT BINDING ===== */
  function bindEvents() {
    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen) closeDrawer();
    });

    /* Cart icon clicks */
    document.addEventListener('click', function(e) {
      var cartLink = e.target.closest('.js-drawer-open-cart, a[href="/cart"]');
      if (cartLink && cartLink.tagName === 'A' &&
          (cartLink.classList.contains('js-drawer-open-cart') ||
           cartLink.classList.contains('site-nav__link--icon'))) {
        e.preventDefault();
        e.stopPropagation();
        fetchCart(true);
      }
    }, true);

    /* Legacy: ajaxProduct:added */
    document.addEventListener('ajaxProduct:added', function() {
      fetchCart(true);
    });

    /* New web component: product-form events */
    document.addEventListener('product-form:cart:navigate', function(e) {
      e.preventDefault();
      fetchCart(true);
    });
    document.addEventListener('product-form:submit:success', function() {
      fetchCart(true);
    });

    /* Intercept bare add-to-cart forms */
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (form.action && form.action.indexOf('/cart/add') !== -1 && form.method.toLowerCase() === 'post') {
        if (form.closest('product-form') || form.hasAttribute('data-product-form')) return;
        e.preventDefault();
        var formData = new FormData(form);
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.classList.add('btn--loading');

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (btn) btn.classList.remove('btn--loading');
          if (data.status === 422) {
            alert(data.description || "Erreur lors de l'ajout au panier");
          } else {
            fetchCart(true);
          }
        })
        .catch(function() {
          if (btn) btn.classList.remove('btn--loading');
        });
      }
    });

    /* Stepper + remove (delegated) */
    drawerItems.addEventListener('click', function(e) {
      var minus = e.target.closest('[data-eki-minus]');
      var plus = e.target.closest('[data-eki-plus]');
      var remove = e.target.closest('[data-eki-remove]');

      if (minus) {
        var key = minus.getAttribute('data-eki-minus');
        var item = findItem(key);
        if (item && item.quantity > 1) updateQuantity(key, item.quantity - 1);
        else if (item) updateQuantity(key, 0);
      }
      if (plus) {
        var key2 = plus.getAttribute('data-eki-plus');
        var item2 = findItem(key2);
        if (item2) updateQuantity(key2, item2.quantity + 1);
      }
      if (remove) {
        var key3 = remove.getAttribute('data-eki-remove');
        updateQuantity(key3, 0);
      }
    });

    /* Upsell stepper + add buttons (delegated on drawer body) */
    drawerBody.addEventListener('click', function(e) {
      var minus = e.target.closest('[data-eki-upsell-minus]');
      if (minus) {
        var vid = minus.getAttribute('data-eki-upsell-minus');
        var qtyInput = drawerBody.querySelector('[data-eki-upsell-qty="' + vid + '"]');
        if (qtyInput) {
          var val = parseInt(qtyInput.value, 10);
          if (val > 1) qtyInput.value = val - 1;
        }
        return;
      }

      var plus = e.target.closest('[data-eki-upsell-plus]');
      if (plus) {
        var vid2 = plus.getAttribute('data-eki-upsell-plus');
        var qtyInput2 = drawerBody.querySelector('[data-eki-upsell-qty="' + vid2 + '"]');
        if (qtyInput2) {
          var val2 = parseInt(qtyInput2.value, 10);
          if (val2 < 10) qtyInput2.value = val2 + 1;
        }
        return;
      }

      var addBtn = e.target.closest('[data-eki-upsell-add]');
      if (!addBtn) return;
      var variantId = addBtn.getAttribute('data-eki-upsell-add');
      if (!variantId) return;
      var qtyEl = drawerBody.querySelector('[data-eki-upsell-qty="' + variantId + '"]');
      var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
      addUpsellToCart(variantId, qty, addBtn);
    });
  }

  /* ===== OPEN / CLOSE ===== */
  function openDrawer() {
    if (isOpen) return;
    isOpen = true;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.body.classList.add('eki-drawer-open');
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    document.body.classList.remove('eki-drawer-open');
  }

  /* ===== FETCH CART ===== */
  function fetchCart(shouldOpen) {
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      cartData = data;
      renderCart();
      renderUpsell();
      updateNavbarCount(data.item_count);
      if (shouldOpen) openDrawer();
    })
    .catch(function(err) {
      console.error('Eki Cart: fetch error', err);
    });
  }

  /* ===== UPDATE QUANTITY ===== */
  function updateQuantity(key, qty) {
    if (isUpdating) return;
    isUpdating = true;

    var itemEl = drawerItems.querySelector('[data-eki-item="' + key + '"]');
    if (itemEl) itemEl.classList.add('is-loading');

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      cartData = data;
      renderCart();
      renderUpsell();
      updateNavbarCount(data.item_count);
      isUpdating = false;
    })
    .catch(function() {
      isUpdating = false;
      fetchCart(false);
    });
  }

  /* ===== ADD UPSELL TO CART ===== */
  function addUpsellToCart(variantId, qty, btn) {
    if (isUpdating) return;
    isUpdating = true;
    btn.classList.add('is-adding');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty || 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status === 422) {
        alert(data.description || "Produit indisponible");
        btn.classList.remove('is-adding');
        isUpdating = false;
      } else {
        fetchCart(false);
        isUpdating = false;
      }
    })
    .catch(function() {
      btn.classList.remove('is-adding');
      isUpdating = false;
    });
  }

  /* ===== FIND ITEM ===== */
  function findItem(key) {
    if (!cartData || !cartData.items) return null;
    for (var i = 0; i < cartData.items.length; i++) {
      if (cartData.items[i].key === key) return cartData.items[i];
    }
    return null;
  }

  /* ===== RENDER CART ===== */
  function renderCart() {
    if (!cartData) return;

    var items = cartData.items;
    var count = cartData.item_count;
    var subtotal = cartData.total_price;

    /* Update header count */
    if (drawerCount) {
      drawerCount.textContent = count > 0 ? '(' + count + ')' : '';
    }

    /* Show/hide states */
    if (count === 0) {
      drawerBody.style.display = 'none';
      drawerFooter.style.display = 'none';
      drawerEmpty.style.display = 'flex';
      progressEl.style.display = 'none';
    } else {
      drawerBody.style.display = 'block';
      drawerFooter.style.display = 'block';
      drawerEmpty.style.display = 'none';
      progressEl.style.display = 'block';
    }

    /* Render items */
    var html = '';
    var totalCompare = 0;
    for (var i = 0; i < items.length; i++) {
      html += renderItem(items[i]);
      totalCompare += items[i].original_price * items[i].quantity;
    }
    drawerItems.innerHTML = html;

    /* Progress bar (3 tiers) */
    updateProgress(subtotal);

    /* Shipping cost */
    updateShipping(subtotal);

    /* Subtotal */
    var countText = count === 1 ? '1 article' : count + ' articles';
    subtotalLabel.textContent = 'Sous-total (' + countText + ')';
    subtotalCurrent.textContent = formatMoney(subtotal);

    if (totalCompare > subtotal) {
      subtotalCurrent.classList.add('has-discount');
      subtotalCompare.textContent = formatMoney(totalCompare);
      subtotalCompare.style.display = 'inline';
    } else {
      subtotalCurrent.classList.remove('has-discount');
      subtotalCompare.style.display = 'none';
    }

    /* Checkout button text with total */
    if (checkoutText) {
      checkoutText.textContent = 'FINALISER MA COMMANDE \u2014 ' + formatMoney(subtotal);
    }
  }

  /* ===== RENDER UPSELL ===== */
  function renderUpsell() {
    if (!upsellSection || !upsellGrid || !upsellProducts.length) return;
    if (!cartData || !cartData.items || cartData.items.length === 0) {
      upsellSection.style.display = 'none';
      return;
    }

    var cartHandles = {};
    for (var i = 0; i < cartData.items.length; i++) {
      cartHandles[cartData.items[i].handle] = true;
    }

    var suggestions = [];
    for (var j = 0; j < upsellProducts.length; j++) {
      if (!cartHandles[upsellProducts[j].handle]) {
        suggestions.push(upsellProducts[j]);
      }
    }

    if (suggestions.length === 0) {
      upsellSection.style.display = 'none';
      return;
    }

    var html = '';
    for (var k = 0; k < suggestions.length; k++) {
      html += renderUpsellCard(suggestions[k]);
    }
    upsellGrid.innerHTML = html;
    upsellSection.style.display = 'block';
  }

  /* ===== RENDER UPSELL CARD ===== */
  function renderUpsellCard(product) {
    var title = escapeHtml(product.title);
    var onSale = product.compare_at_price && product.compare_at_price > product.price;

    var priceHtml = '';
    if (onSale) {
      priceHtml = '<span class="eki-drawer__upsell-card-price eki-drawer__upsell-card-price--sale">' + formatMoney(product.price) + '</span>' +
                  '<span class="eki-drawer__upsell-card-compare">' + formatMoney(product.compare_at_price) + '</span>';
    } else {
      priceHtml = '<span class="eki-drawer__upsell-card-price">' + formatMoney(product.price) + '</span>';
    }

    return '<div class="eki-drawer__upsell-card">' +
      '<a href="' + product.url + '" class="eki-drawer__upsell-card-img">' +
        '<img src="' + product.image + '" alt="' + title + '" loading="lazy">' +
      '</a>' +
      '<div class="eki-drawer__upsell-card-body">' +
        '<a href="' + product.url + '" class="eki-drawer__upsell-card-name">' + title + '</a>' +
        '<div class="eki-drawer__upsell-card-prices">' + priceHtml + '</div>' +
        '<div class="eki-drawer__upsell-card-bottom">' +
          '<div class="eki-drawer__upsell-stepper">' +
            '<button type="button" class="eki-drawer__upsell-stepper-btn" data-eki-upsell-minus="' + product.variant_id + '">&minus;</button>' +
            '<input type="number" class="eki-drawer__upsell-stepper-qty" data-eki-upsell-qty="' + product.variant_id + '" value="1" min="1" max="10" readonly>' +
            '<button type="button" class="eki-drawer__upsell-stepper-btn" data-eki-upsell-plus="' + product.variant_id + '">+</button>' +
          '</div>' +
          '<button type="button" class="eki-drawer__upsell-add" data-eki-upsell-add="' + product.variant_id + '">Ajouter</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  /* ===== RENDER SINGLE ITEM ===== */
  function renderItem(item) {
    var imgSrc = item.image ? getSizedImage(item.image, '240x') : '';
    var title = escapeHtml(item.product_title);
    var variant = item.variant_title ? escapeHtml(item.variant_title) : '';
    var onSale = item.original_price > item.final_price;
    var lineTotal = item.final_line_price;
    var lineCompare = item.original_line_price;

    var priceHtml = '';
    if (onSale) {
      priceHtml = '<span class="eki-drawer__item-price eki-drawer__item-price--sale">' + formatMoney(lineTotal) + '</span>' +
                  '<span class="eki-drawer__item-compare">' + formatMoney(lineCompare) + '</span>';
    } else {
      priceHtml = '<span class="eki-drawer__item-price">' + formatMoney(lineTotal) + '</span>';
    }

    /* Subscription badge */
    var subscriptionHtml = '';
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      var spName = escapeHtml(item.selling_plan_allocation.selling_plan.name);
      subscriptionHtml = '<div class="eki-drawer__item-subscription">' +
        '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" style="vertical-align:-2px;margin-right:3px;">' +
          '<path d="M11.5 7.5A4.5 4.5 0 117 2.5M7 5V2.5L9 1" stroke="#16a34a" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
        spName + '</div>';
    }

    var discountHtml = '';
    if (item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
      for (var d = 0; d < item.line_level_discount_allocations.length; d++) {
        discountHtml += '<div class="eki-drawer__item-discount-tag">' +
          escapeHtml(item.line_level_discount_allocations[d].discount_application.title) +
          '</div>';
      }
    }

    var trashSvg = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M3.5 5h11M7 5V3.5a1 1 0 011-1h2a1 1 0 011 1V5M5 5v10a1 1 0 001 1h6a1 1 0 001-1V5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    return '<div class="eki-drawer__item" data-eki-item="' + item.key + '">' +
      '<div class="eki-drawer__item-img">' +
        (imgSrc ? '<a href="' + item.url + '"><img src="' + imgSrc + '" alt="' + title + '" loading="lazy"></a>' : '') +
      '</div>' +
      '<div class="eki-drawer__item-info">' +
        '<a href="' + item.url + '" class="eki-drawer__item-title">' + title + '</a>' +
        (variant ? '<div class="eki-drawer__item-variant">' + variant + '</div>' : '') +
        subscriptionHtml +
        discountHtml +
        '<button type="button" class="eki-drawer__item-delete" data-eki-remove="' + item.key + '" aria-label="Supprimer">' + trashSvg + '</button>' +
        '<div class="eki-drawer__item-bottom">' +
          '<div class="eki-drawer__stepper">' +
            '<button type="button" class="eki-drawer__stepper-btn" data-eki-minus="' + item.key + '" aria-label="Diminuer">&minus;</button>' +
            '<input type="number" class="eki-drawer__stepper-qty" value="' + item.quantity + '" min="0" readonly>' +
            '<button type="button" class="eki-drawer__stepper-btn" data-eki-plus="' + item.key + '" aria-label="Augmenter">+</button>' +
          '</div>' +
          '<div class="eki-drawer__item-prices">' + priceHtml + '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  /* ===== UPDATE PROGRESS BAR (single dot at 60%) ===== */
  function updateProgress(subtotal) {
    /* Fill goes 0→60% for 0→60EUR, then 60→100% for overshoot */
    var fillPct;
    if (subtotal <= FREE_SHIPPING_THRESHOLD) {
      fillPct = Math.round((subtotal / FREE_SHIPPING_THRESHOLD) * 60);
    } else {
      fillPct = Math.min(100, 60 + Math.round(((subtotal - FREE_SHIPPING_THRESHOLD) / FREE_SHIPPING_THRESHOLD) * 40));
    }
    progressFill.style.width = fillPct + '%';

    /* Toggle dot state */
    var dot = document.getElementById('EkiProgressDot');
    if (dot) {
      if (subtotal >= FREE_SHIPPING_THRESHOLD) {
        dot.classList.add('is-complete');
      } else {
        dot.classList.remove('is-complete');
      }
    }

    /* Message */
    if (subtotal >= FREE_SHIPPING_THRESHOLD) {
      progressMsg.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="vertical-align:-2px;margin-right:4px;"><path d="M13.5 4.5L6 12L2.5 8.5" stroke="#16a34a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><strong style="color:#16a34a;">Livraison offerte d\u00e9bloqu\u00e9e !</strong>';
    } else {
      var remaining = FREE_SHIPPING_THRESHOLD - subtotal;
      progressMsg.innerHTML = 'Plus que <strong>' + formatMoney(remaining) + '</strong> pour la livraison offerte';
    }
  }

  /* ===== UPDATE SHIPPING COST ===== */
  function updateShipping(subtotal) {
    if (!shippingRow) return;
    if (subtotal >= FREE_SHIPPING_THRESHOLD) {
      shippingRow.classList.add('is-free');
    } else {
      shippingRow.classList.remove('is-free');
      if (shippingCost) {
        shippingCost.textContent = formatMoney(SHIPPING_COST);
      }
    }
  }

  /* ===== UPDATE NAVBAR COUNT ===== */
  function updateNavbarCount(count) {
    var bubbles = document.querySelectorAll('.cart-link__bubble');
    bubbles.forEach(function(b) {
      if (count > 0) {
        b.classList.add('cart-link__bubble--visible');
      } else {
        b.classList.remove('cart-link__bubble--visible');
      }
    });
    var countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function(el) {
      el.textContent = count;
    });
    var headerCount = document.querySelector('.cart-link__count');
    if (headerCount) headerCount.textContent = count;
  }

  /* ===== HELPERS ===== */
  function formatMoney(cents) {
    if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + '\u00a0\u20ac';
  }

  function getSizedImage(src, size) {
    if (!src) return '';
    return src.replace(/(\.[^.]+)$/, '_' + size + '$1').replace('http:', 'https:');
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /* ===== BOOT ===== */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
